/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonInviteInfo,
    JsonInviteInfoFromJSON,
    JsonInviteInfoFromJSONTyped,
    JsonInviteInfoToJSON,
} from './JsonInviteInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonInviteInfo
 */
export interface ApiResultOfListOfJsonInviteInfo {
    /**
     * 
     * @type {Array<JsonInviteInfo>}
     * @memberof ApiResultOfListOfJsonInviteInfo
     */
    data?: Array<JsonInviteInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonInviteInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonInviteInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonInviteInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonInviteInfo
     */
    result?: ApiResultOfListOfJsonInviteInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonInviteInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonInviteInfoFromJSON(json: any): ApiResultOfListOfJsonInviteInfo {
    return ApiResultOfListOfJsonInviteInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonInviteInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonInviteInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonInviteInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonInviteInfoToJSON(value?: ApiResultOfListOfJsonInviteInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonInviteInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

